export default {
  API_URL: process.env.VUE_APP_API_URL || 'https://app.dragoncup.pl/api',
  VERSION: process.env.VUE_APP_VERSION || '1.0.0'
}
